import React from "react";
import { Box } from "@mui/material";
import Header from "../shared/header";
import ResetPasswordForm from "../shared/forms/reset-password";

/**
 * Reset Password page component that allows users to set a new password after receiving a reset link.
 * The page displays a centered layout with a header and the reset password form.
 * 
 * @component
 * @returns {JSX.Element} A centered box containing the reset password UI
 * 
 * @example
 * ```tsx
 * <ResetPasswordPage />
 * ```
 */
const ResetPasswordPage = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh" /* Adjust the height as needed */
    >
      <Box width="60%" m="20px">
        <Box textAlign="center">
          <Header
            title="careblue controllcenter"
            subtitle="Bitte setzen Sie ein neues Passwort!"
          />
        </Box>
        <ResetPasswordForm />
      </Box>
    </Box>
  );
};

export default ResetPasswordPage;
